import { AbstractControl, ValidatorFn } from '@angular/forms';
import { GlobalConstants } from '@app-core';

export class EmailValidator {
    static email(): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } | null => {
            const emailPattern = GlobalConstants.VALIDATION_REGEX.emailPattern;
            const valid = emailPattern.test(control.value);
            return valid ? null : { invalidEmail: { value: control.value } };
        };
    }
}
